<template>
  <div class="hello">
    <div class="subTitle">周口天立高中</div>
    <div class="payButton">
      <van-button
          v-for="item in payButtons"
          :key="item.label"
          round
          block
          size="large"
          icon="bill-o"
          :color="buttonGradient"
          class="pay-btn"
          @click="goTo(item.url)"
      >
        {{ item.label }}
      </van-button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'zktlgz',
  data() {
    return {
      // 按钮配置数组（可维护性强）
      payButtons: [
        {
          label: '学费',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmMzt5uGYqqMCvG4tLTQO1WyTdaIB71loFjg74TCa+hLuA1fCy+d4J02A55Xfdk1Sg1bg06ma9CtfbNg+1y6remE35FGh85y2s/uV+JDkAMTimT7fujPotC3V598qB8yppXXJe0FEKxuOMc8jfqcwAnoY='
        },
        {
          label: '综合服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM2MVCP+3i2o62dKyAyvTUOGfyGfO1PplN6gkIH5lgsNUq/b2TbgOHh0SMjxwzo9L9885idQJMSoOHMfqTJaYZIr0ErMDimgAVj0d9dDfnCRFtmppCUZu8iKvUWkvZgchZfbQ/FFEWxXtgFZrPMR4ODw='
        }
      ],
      buttonGradient: 'linear-gradient(to right, #0055ff, #00aaff)',
    };
  },
  created() {
    document.title = '周口天立高中';
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subTitle {
  margin-top: 10px;
  font-size: 28px;
  padding-bottom: 16px;
  text-align: center;
}

.payButton {
  margin: 20px auto;
  width: 75vw;
}

.pay-btn {
  margin-bottom: 16px; /* 替代 br 和 div 高度 */
}
</style>

